import { request } from '_api/v1/base/behemoth/client'

import { splitAPIOptions } from '_api/utils/tools'

export const getServiceOutages = async (options) => {
    const { filters, params } = splitAPIOptions(options)

    return await request('POST', 'v1/outage/outage/list/', filters, { params })
}

export const createServiceOutage = async (params) => {
    await request('POST', 'v1/outage/outage/create/', params)
}

export const unactivateServiceOutage = async (params) => {
    await request('POST', 'v1/outage/outage/activate/', params)
}

export const deleteServiceOutage = async (params) => {
    await request('POST', 'v1/outage/outage/delete/', params)
}

export const extensionServiceOutage = async (params) => {
    await request('POST', 'v1/outage/outage/extension/', params)
}

export const getServiceOutageResources = async (options) => {
    const { filters, params } = splitAPIOptions(options)

    return await request('POST', 'v1/outage/resource/list/', filters, { params })
}

export const getServiceOutageResourceDetails = async (options) => {
    const { filters, params } = splitAPIOptions(options)

    return await request('POST', 'v1/outage/resource/detail/', filters, { params })
}

export const getServiceOutageReasons = async (options) => {
    const { filters, params } = splitAPIOptions(options)

    return await request('POST', 'v1/outage/reason/list/', filters, { params })
}

export const getServiceOutageTypes = async (options) => {
    const { filters, params } = splitAPIOptions(options)

    return await request('POST', 'v1/outage/type/list/', filters, { params })
}
